module.exports = __webpack_public_path__ + "media/images/icons/icon-pending-circle-f2b76d4e82174d18d75170db7d823e8f.svg";